// --- React & Redux
import React from "react";
import { useSelector } from "react-redux";
// --- Components
import { UploadJobTasksList } from "tap/components/UploadJobTasksList";

export function JobTasksForm() {
  const { rateCardJobTasks } = useSelector((state) => state.rateCards);

  return <UploadJobTasksList tasks={rateCardJobTasks} />;
}
